import $ from 'jquery';
import {displayMessages, destroyMessages, destroyFieldHighlights, displayFieldHighlights } from 'stdjs/validation';
import { formDataAvailable, isFormData } from 'stdjs/utilities';
import Translator from 'stdjs/translate-service';
import { showErrorMessage  } from 'stdjs/toast';
import { hideLoadingSpinner, hideProgressDialog, showLoadingSpinner, showProgressDialog, showProgressDialogSummary, updateProgressDialogWithServerEvent } from './progress';

// TODO add in 'transportError' callback. Switch to accepting an array of options after success?
function standardAjaxCore(method, url, data, successCallback, errorCallback, global, showMessages, streaming, streamingOptions ){
    
    if (typeof successCallback === "undefined" || typeof successCallback !== "function"){
        successCallback = function(data){};
    }
    
    if (typeof errorCallback === "undefined" || typeof errorCallback !== "function"){
        errorCallback = null;
    }
    
    if (typeof global === "undefined" || global === null){
        global = true;
    }
    
    if (typeof method === "undefined" || method === null){
        method = "POST";
    }

    if (typeof showMessages === "undefined" || showMessages === null){
        showMessages = true;
    }
    
    if (typeof streaming === "undefined" || streaming === null){
        streaming = false;
    }
    
    if (typeof streamingOptions === "undefined" || streamingOptions === null){
        streamingOptions = {};
    }
    
    if (typeof streamingOptions[ 'showProgressDialog' ] === "undefined" || streamingOptions[ 'showProgressDialog' ] === null ){
        streamingOptions.showProgressDialog = true;
    }
    
    if (typeof streamingOptions[ 'progressCallback' ] === "undefined" || typeof streamingOptions[ 'progressCallback' ] !== "function"){
        streamingOptions.progressCallback = function( message ){};
    }
    
    if (typeof streamingOptions[ 'showProgressDialogSummaryOnComplete' ] === "undefined" || streamingOptions[ 'showProgressDialogSummaryOnComplete' ] === null ){
        streamingOptions.showProgressDialogSummaryOnComplete = false;
    }
    
    if (method !== "POST" && method !== "GET"){
        method = "GET";
    }
    
    var formDataUsed = formDataAvailable() && isFormData(data);
    var contentType = formDataUsed ? false : "application/x-www-form-urlencoded; charset=UTF-8";
    var processData = formDataUsed ? false : true;
    
    // Used in streaming
    var currentResponseLength = 0;
    var responseBuffer = "";
    var finalAjaxResponse = null;
    
    var progressDialogShown = streaming  &&  streamingOptions.showProgressDialog;
    var progressDialogSummaryRequested = progressDialogShown  &&  streamingOptions.showProgressDialogSummaryOnComplete;
    
    var ajaxOptions = {
        type: method,
        dataType: "json",
        url: url,
        cache: false,
        data: data,
        global: global,
        contentType: contentType,
        processData: processData,
        beforeSend: function() {
            destroyMessages();
            destroyFieldHighlights();
        },
        success: function(data) {
            
            if ( streaming ){
                data = finalAjaxResponse;
            }
            
            var ajaxSuccess = data[ 'success' ] ?? false;
            
            if ( ajaxSuccess  &&  progressDialogSummaryRequested ){
                showProgressDialogSummary( function(){
                    processStandardAjaxResponse( data, successCallback, errorCallback, showMessages );
                });
            } else {
                
                if ( progressDialogShown ){
                    hideProgressDialog();
                }
                
                if ( global ){
                    hideLoadingSpinner();
                }
                
                processStandardAjaxResponse( data, successCallback, errorCallback, showMessages );
                
            }
            
        },
        error: function(){
            var errorMessage = Translator.tr( "A transport error occurred. Please try again." );
            
            if ( progressDialogShown ){
                hideProgressDialog();
            }
            
            if ( global ){
                hideLoadingSpinner();
            }
            
            if ( errorCallback === null ){
                showErrorMessage( errorMessage );
            } else {
                data = {
                    success: false,
                    defaultMessages: [],
                    errorMessages:[errorMessage], 
                    warningMessages:[],
                    infoMessages:[],
                    successMessages: [],
                    errorFieldHighlights:[],
                    warningFieldHighlights:[], 
                    infoFieldHighlights: [],
                    successFieldHighlights: []
                }
                errorCallback(data);
            }
        }
    };
    
    if ( streaming ){
        
        ajaxOptions[ 'dataType' ] = 'text';
        
        ajaxOptions[ 'headers' ] = {
            'X-Merisis-Ajax-Stream': "1"
        };
        
        ajaxOptions[ 'xhrFields' ] = {
            onprogress: function(e) {
                
                var response = e.currentTarget.response;

                var currentChunk = response.substring( currentResponseLength );
                
                currentResponseLength = response.length;
                
                responseBuffer += currentChunk;
                
                if ( responseBuffer.length ){
                    
                    var messagesBuffer = responseBuffer.split( "\n\n" );
                    var noMessagesInBuffer = messagesBuffer.length;
                    var newBuffer = "";
                    
                    for ( var i = 0; i < noMessagesInBuffer; i++){
                        var isLastMessageInBuffer = i === noMessagesInBuffer - 1;
                        
                        var currentMessage = messagesBuffer[ i ];
                        
                        if ( currentMessage.trim() === "" ){
                            continue;
                        }
                        
                        try {
                            var decodedMessage = JSON.parse( currentMessage );
                            streamingOptions.progressCallback( decodedMessage );
                            
                            if ( $.isPlainObject( decodedMessage ) ){
                                if ( decodedMessage.hasOwnProperty( 'success' ) ){
                                    finalAjaxResponse = decodedMessage;
                                }
                                
                                if ( streamingOptions.showProgressDialog ){
                                    updateProgressDialogWithServerEvent( decodedMessage );
                                }
                            }
                            
                        } catch ( err ){
                            console.log( err );
                            if ( isLastMessageInBuffer ){
                                newBuffer = currentMessage;
                            }
                        }
                    }
                    
                    responseBuffer = newBuffer;
                }

            }
        }
        
        if ( streamingOptions.showProgressDialog ){
            showProgressDialog();
        }
    }
    
    if ( global ){
        showLoadingSpinner();
    }
    
    $.ajax( ajaxOptions );
    
    
}



function processAjaxJavascriptVariables( data ){
    if ( typeof data[ "jsVariables" ] !== "undefined" ){
        $.each( data[ "jsVariables" ], function( index, value ) {
            window[ value.name ] = value.value;
        });
    }
}

export function processStandardAjaxResponse( data, successCallback, errorCallback, showMessages ){
    
    if (typeof successCallback === "undefined" || typeof successCallback !== "function"){
        successCallback = function(data){};
    }
    
    if (typeof errorCallback === "undefined" || typeof errorCallback !== "function"){
        errorCallback = null;
    }
    
    if (typeof showMessages === "undefined" || showMessages === null){
        showMessages = true;
    }
    
    if (data.success) {
        
        processAjaxJavascriptVariables( data );
                
        if (showMessages){
            displayMessages(data.errorMessages, data.warningMessages, data.infoMessages, data.successMessages, data.defaultMessages);
            displayFieldHighlights(data.errorFieldHighlights, data.warningFieldHighlights, data.infoFieldHighlights); 
        }        
        successCallback(data);                        

    } else {
        if (typeof(data["loggedout"]) !== undefined && data["loggedout"]) {

            location.href = notAuthUrl;

        } else {

            if (errorCallback === null){
                //$.jGrowl(data["message"]);  
                if (showMessages){
                    displayMessages(data.errorMessages, data.warningMessages, data.infoMessages, data.successMessages, data.defaultMessages);
                    displayFieldHighlights(data.errorFieldHighlights, data.warningFieldHighlights, data.infoFieldHighlights);
                }
            
            }
            else {
                errorCallback(data);
            }

        }  
    }

}

export function standardAjaxPost(url, data, successCallback, errorCallback, global, showMessages){
    standardAjaxCore("POST", url, data, successCallback, errorCallback, global, showMessages);  
}

export function standardAjaxGet(url, data, successCallback, errorCallback, global, showMessages){
    standardAjaxCore("GET", url, data, successCallback, errorCallback, global, showMessages);
}

export function standardAjaxPostStream( url, data, successCallback, errorCallback, global, streamingOptions ){
    return standardAjaxCore( 'POST', url, data, successCallback, errorCallback, global, true, true, streamingOptions );
}

export function standardAjaxErrorCallback(data, $context = null){
    displayMessages(data.errorMessages, data.warningMessages, data.infoMessages, data.successMessages, data.defaultMessages);
    displayFieldHighlights(data.errorFieldHighlights, data.warningFieldHighlights, data.infoFieldHighlights, $context);
}
